import { BannerAd } from "@src/types/BannerAd";
import { BannerActionEnum, MediaPurpose } from "./types";
import { DeviceType, ProductCategory } from "@utils/constants";
import { Platform } from "react-native";

export const createAdProps = (
  action: BannerActionEnum,
  adsData: BannerAd,
  additionalProp?: any
) => ({
  advertisement_type_enum: getAdvertisementType(adsData.media_purpose),
  banner_description: adsData.banner_desc,
  banner_redirection_link: adsData.media_redirect_link,
  banner_action_enum: action,
  banner_media_type: adsData.media_type,
  product_type_enum: getProductNum(adsData.product_type),
  timestamp: new Date().toISOString(),
  device_type_enum: getDeviceType(Platform.OS).toString(),
  ...additionalProp,
});

export const getDeviceType = (platform?: string) => {
  switch (platform) {
    case DeviceType.WEB:
      return 0;
    case DeviceType.IOS:
      return 1;
    case DeviceType.ANDROID:
      return 2;
    default:
      return 2;
  }
};

export const getProductNum = (productType: String) => {
  switch (productType) {
    case ProductCategory.DIAMOND:
      return 0;
    case ProductCategory.GEMSTONE:
      return 2;
    case ProductCategory.JEWELRY:
      return 3;
    case ProductCategory.LAB_GROWN_DIAMOND:
      return 1;
    case ProductCategory.LABGROWN_JEWELRY:
      return 5;
    case ProductCategory.HOME:
      return 4;
    default:
      return 4;
  }
};

export const getAdvertisementType = (mediaPurpose: String) => {
  switch (mediaPurpose) {
    case MediaPurpose.BANNER:
      return 0;
    case MediaPurpose.MODAL:
      return 1;
    case MediaPurpose.GRID:
      return 2;
    case MediaPurpose.LIST:
      return 3;
    case MediaPurpose.LIST_IPAD:
      return 4;
  }
};
